module.exports = __webpack_public_path__ + "static/media/insights_process2.fc570c87.png";